import { modalType } from '../../util/ModalUtil';
import { useDispatch } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';
import SelectionBox from '../../component/SelectionBox';
import InputBox from '../../component/InputBox';
import { actionUniversityAdd, actionUniversityEdit } from '../../module/body/system/SystemUniversityModule';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import PopupRef from '../../component/PopupRef';
import NullCheckUtil from '../../util/NullCheckUtil';
import { UNIVERSITY_TYPE, ENROLMENT_ENABLE_STATUS } from '../../constant/Constant';

const SystemUniversityModal = ({ type, modalRef, row, callback }) => {
    const dispatch = useDispatch();
    const popupRef = useRef(null);

    const [universityCd, setUniversityCd] = useState(row && row.universityCd);
    const [sortSeq, setSortSeq] = useState(row && row.sortSeq);
    const [universityTypeCd, setUniversityTypeCd] = useState(
        (row && row.universityTypeCd) || CodeUtil.getFirstCode(CODE_GROUP_ID.UNIVERSITY_TYPE),
    );
    const [universityNm, setUniversityNm] = useState(row && row.universityNm);
    const [mainUnivState, setMainUnivState] = useState(true);
    const [mainUniversityCd, setMainUniversityCd] = useState(
        (row && row.mainUniversityCd) || CodeUtil.getFirstCode(CODE_GROUP_ID.MAIN_UNIVERSITY),
    );
    const [enrolmentEnableStatusCd, setEnrolmentEnableStatusCd] = useState(
        (row && row.enrolmentEnableStatusCd) || CodeUtil.getFirstCode(CODE_GROUP_ID.ENROLMENT_ENABLE_STATUS),
    );
    const [universityEmail, setUniversityEmail] = useState(row && row.universityEmail);

    const [useStatusCd, setUseStatusCd] = useState(row && row.useStatusCd);

    const handleCancel = () => {
        modalRef.current.close();
    };

    useEffect(() => {
        if (UNIVERSITY_TYPE.MAIN === universityTypeCd) {
            setMainUnivState(true);
            setMainUniversityCd(universityCd);
        } else {
            setEnrolmentEnableStatusCd(ENROLMENT_ENABLE_STATUS.DISABLED);
            setMainUnivState(false);
        }
    }, [universityTypeCd, universityCd]);

    const handleConfirm = () => {
        if (validateStaff()) {
            dispatch(
                (type == modalType.ADD ? actionUniversityAdd : actionUniversityEdit)({
                    data: {
                        universityCd,
                        sortSeq,
                        universityTypeCd,
                        universityNm,
                        mainUniversityCd,
                        enrolmentEnableStatusCd,
                        universityEmail,
                        useStatusCd,
                    },
                    callback: () => {
                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                            return function () {
                                callback();
                                modalRef.current.close();
                            };
                        });
                    },
                }),
            );
        }
    };

    const validateStaff = () => {
        if (NullCheckUtil.isEmpty(universityCd)) {
            popupRef.current.openAlert('대학코드를 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(universityNm)) {
            popupRef.current.openAlert('대학명을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(sortSeq)) {
            popupRef.current.openAlert('순번을 입력해주세요.');
            return false;
        }

        return true;
    };

    return (
        <>
            <ModalHeader title={type == modalType.ADD ? '참여대학 등록' : '참여대학 수정'} modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner SystemUniversityModal'>
                    <InfoTxt
                        infoTxt={type == modalType.ADD ? '참여대학 정보를 등록합니다.' : '참여대학 정보를 수정합니다.'}
                    />
                    <div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='대학타입'
                                options={CodeUtil.getCodes(CODE_GROUP_ID.UNIVERSITY_TYPE)}
                                value={universityTypeCd}
                                onChange={(e) => setUniversityTypeCd(e.target.value)}
                                useAll={false}
                            />
                            <InputBox
                                title='대학코드'
                                value={universityCd}
                                disabled={type == modalType.EDIT}
                                onChange={(e) => setUniversityCd(e.target.value)}
                            />
                            <InputBox
                                title='대학명'
                                value={universityNm}
                                onChange={(e) => setUniversityNm(e.target.value)}
                            />
                        </div>
                        <div className='form-box-row'>
                            {!mainUnivState && (
                                <SelectionBox
                                    title='주관대학'
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY)}
                                    value={mainUniversityCd}
                                    onChange={(e) => setMainUniversityCd(e.target.value)}
                                    useAll={false}
                                />
                            )}
                            {mainUnivState && (
                                <SelectionBox
                                    title='수강신청가능상태'
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.ENROLMENT_ENABLE_STATUS)}
                                    value={enrolmentEnableStatusCd}
                                    onChange={(e) => setEnrolmentEnableStatusCd(e.target.value)}
                                    useAll={false}
                                />
                            )}
                            <InputBox
                                title='순번'
                                number
                                value={sortSeq}
                                onChange={(e) => setSortSeq(e.target.value)}
                            />
                        </div>
                        <div className='form-box-row'>
                            <InputBox
                                title='학교 이메일'
                                value={universityEmail}
                                onChange={(e) => setUniversityEmail(e.target.value)}
                            />
                            <SelectionBox
                                title='사용여부'
                                options={CodeUtil.getCodes(CODE_GROUP_ID.USE_STATUS)}
                                value={useStatusCd}
                                onChange={(e) => setUseStatusCd(e.target.value)}
                                useAll={false}
                            />
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default SystemUniversityModal;
